/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AuditLogsEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const auditLogsEntryPoint: EntryPoint<AuditLogsEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<AuditLogsEntryPointComponent>(
		/* webpackChunkName: "async-audit-logs-page" */ './AuditLogs.tsx',
	),
	getPreloadProps: () => ({}),
});
